import * as React from 'react';
import type { SVGProps } from 'react';
const SvgWidgetNoData = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 87 83"
    {...props}
  >
    <path
      fill="url(#WidgetNoData_svg__a)"
      d="m58.683 48.27-8.044 8.869 22.673 20.566 8.044-8.868z"
    />
    <path
      fill="url(#WidgetNoData_svg__b)"
      fillRule="evenodd"
      d="M67.185 33.593c0 18.552-15.04 33.592-33.592 33.592C15.04 67.185 0 52.145 0 33.593 0 15.04 15.04 0 33.593 0c18.552 0 33.592 15.04 33.592 33.593m-5.152 0c0 15.706-12.733 28.44-28.44 28.44-15.706 0-28.44-12.734-28.44-28.44 0-15.708 12.734-28.44 28.44-28.44s28.44 12.733 28.44 28.44"
      clipRule="evenodd"
    />
    <g filter="url(#WidgetNoData_svg__c)">
      <path
        fill="url(#WidgetNoData_svg__d)"
        fillOpacity={0.2}
        d="M33.594 62.032c15.707 0 28.44-12.733 28.44-28.44 0-15.706-12.733-28.44-28.44-28.44s-28.44 12.734-28.44 28.44 12.733 28.44 28.44 28.44"
      />
    </g>
    <path
      fill="#C5C6D4"
      d="m73.313 77.706 8.044-8.868 1.211 1.1a5.985 5.985 0 0 1-8.04 8.864l-1.212-1.099z"
    />
    <defs>
      <linearGradient
        id="WidgetNoData_svg__a"
        x1={55.862}
        x2={63.982}
        y1={61.895}
        y2={52.989}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E2E2EA" />
        <stop offset={1} stopColor="#C5C6D4" />
      </linearGradient>
      <linearGradient
        id="WidgetNoData_svg__b"
        x1={-0.076}
        x2={67.55}
        y1={15.505}
        y2={15.944}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#C5C6D4" />
      </linearGradient>
      <linearGradient
        id="WidgetNoData_svg__d"
        x1={33.594}
        x2={62.252}
        y1={5.153}
        y2={79.517}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#F3F2FE" />
      </linearGradient>
      <filter
        id="WidgetNoData_svg__c"
        width={75.054}
        height={75.055}
        x={-3.933}
        y={-3.935}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={4.544} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_523_46538"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_523_46538"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default SvgWidgetNoData;
